<template>
    <div class="forward-meeting">
        <header class="d-flex align-items-center justify-content-between px-3 pt-3 pb-2 fw-bold">
            Forward this event
        </header>

        <TagsInput
            class="w-100 px-3"
            :getData="getUsersList"
            :tags="selectedUsers"
            v-on:updateTags="updateTags"
            placeholder="Enter name"
            :is-focus="true"
            :is-for-messaging="true"
            :show-pill="false"
            classes="w-100"
            focusOnInput="true"
        />

        <div class="px-3 pt-2 mt-1">
            <textarea
                class="form-control"
                rows="4"
                v-model="optionalMessage"
                placeholder="Type your message here (Optional)"
            ></textarea>
        </div>

        <!-- Commenting for future use case -->
        <!-- <div class="chat-history-box m-3">
            <div class="form-group form-check custom-checkbox mb-0">
                <input type="checkbox" class="form-check-input" v-model="shareChatHistory" id="meeting-chat-history" />
                <label class="form-check-label" for="meeting-chat-history"> Share entire chat history</label>
            </div>
        </div> -->

        <footer class="d-flex justify-content-end pb-3 mt-3 me-3">
            <button type="button" class="btn btn-light border border-secondary me-2 w-20 bg-white" @click="cancel()">
                Cancel
            </button>
            <button type="button" class="btn btn-primary border border-primary w-20" @click="submit()">Forward</button>
        </footer>
    </div>
</template>

<script lang="ts" src="./ForwardMeetingEvent.ts"></script>
<style scoped>
.forward-meeting {
    width: 26rem;
    background: #f5f5f5;
}
.forward-meeting header {
    font-size: 18px;
}
</style>
